import { TextField } from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import { decimalInvertedReportFormatter } from "../../fomatters/DecimalFormatter";
import InputSelect from "../InputSelect";
import Report from "../Report";

const currentDate = new Date();
currentDate.setMonth(currentDate.getMonth() - 1);

const startDateValue = currentDate.toISOString().split("T")[0];
const endDateValue = new Date().toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function WinLossesBySource() {
  const [startDate, setStartDate] = useState(startDateValue);
  const onStartDateChange = useCallback(
    (event) => setStartDate(event.target.value),
    []
  );

  const [endDate, setEndDate] = useState(endDateValue);
  const onEndDateChange = useCallback(
    (event) => setEndDate(event.target.value),
    []
  );

  const [book, setBook] = useState("");
  const onBookChanged = useCallback((b) => setBook(b), []);
  const { values: books } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/Player/GetBooks`,
  });

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          required
          variant="outlined"
          label="From"
          type="date"
          value={startDate}
          size="small"
          onChange={onStartDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          id="gameDateTime"
          label="To"
          type="date"
          value={endDate}
          size="small"
          onChange={onEndDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Book"
          name="name"
          data={books}
          placeholder="DataFormatter"
          setSelectValue={onBookChanged}
          startValue={""}
        />
      </div>
      <Report
        title="Win-Losses by Source Report"
        groupBy="idAgent"
        getUrl={() => "/Reports/Report_Win_Losses_by_Source"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          StartDate: startDate,
          EndDate: endDate,
          Book: book,
        })}
        getTotals={(data) => ({
          source: "Totals",
          sourceCount: data.reduce((acc, curr) => acc + curr.sourceCount, 0),
          amount: data.reduce((acc, curr) => acc + curr.amount, 0),
        })}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="source">
          Source
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="sourceCount">
          Players
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="amount"
          dataFormat={decimalInvertedReportFormatter}
        >
          Amount
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default WinLossesBySource;
